<main>

  <div class="bg-white">
    <div class="flex justify-center min-h-screen h-full">

      <!-- left side form -->
      <div class="flex items-center w-full max-w-md px-6 py-4 mx-auto lg:w-2/6">
        <div class="flex-1">

          <!-- logo and header -->
          <div class="text-center mb-8">
            <a href="/"><img class="mx-auto w-52" src="../../../../../assets/img/logo_preto.svg" alt="AngolaEncontra"/></a>
          </div>

          <!-- form -->
          <router-outlet></router-outlet>
        </div>
      </div>

      <!-- right side image-->
      <section class="hidden bg-cover lg:block lg:w-2/3" style="background-image: url('assets/login_bg.jpg')">
      </section>

    </div>
  </div>

</main>
